import {
  GroupLabelContext
} from "./F5VAC7MB.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";
import {
  useId,
  useSafeLayoutEffect
} from "./J7Q2EO23.js";
import {
  __spreadValues
} from "./PNRLI7OV.js";

// src/group/group-label.ts
import { useContext } from "react";
var useGroupLabel = createHook((props) => {
  const setLabelId = useContext(GroupLabelContext);
  const id = useId(props.id);
  useSafeLayoutEffect(() => {
    setLabelId == null ? void 0 : setLabelId(id);
    return () => setLabelId == null ? void 0 : setLabelId(void 0);
  }, [setLabelId, id]);
  props = __spreadValues({
    id,
    "aria-hidden": true
  }, props);
  return props;
});
var GroupLabel = createComponent((props) => {
  const htmlProps = useGroupLabel(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  GroupLabel.displayName = "GroupLabel";
}

export {
  useGroupLabel,
  GroupLabel
};
